// Module
var code = `<input type="text" name="copyValue" readonly="readonly" value="{{::value}}" ng-click="selectText()"> <button type="button" ng-click="copyText()" translate="{{buttonKey}}"></button>`;
// Exports
export default code;